import React from 'react';

import { OrderDistributionChartBase } from '../base/OrderDistributionChartBase';


export const OrderDistributionChart = props => {
  const { data } = props;

  return (
    <OrderDistributionChartBase data={data} />
  );
};
